import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";
import { Textfit } from "react-textfit";
import Card from "src/shared/components/Card";
import logEvent from "src/utils/logEvent";
import sunSvg from "src/pods/today/assets/sun.svg";

type TodayResultProps = {
  title?: string;
  text?: string;
};
// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class TodayResult extends React.Component<TodayResultProps> {
  componentDidMount() {
    logEvent({
      eventName: "morning.result.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "morning.result.close",
    });
  }

  render() {
    const { title, text } = this.props;
    return (
      <div sx={todayResultStyle}>
        <Card sx={todayResultCardStyle}>
          <img src={sunSvg} sx={sunStyle} alt="" />
          {title && <h1 sx={titleStyle}>{title}</h1>}
          <Textfit min={32} sx={todayResultTextfitStyle}>
            {text}
          </Textfit>
        </Card>
      </div>
    );
  }
}

const titleStyle: ThemeUIStyleObject = {
  marginTop: RAW_cssValue(50), // make space for the sun icon
  marginBottom: RAW_cssValue("0.5em"),
  lineHeight: "1em",
  fontSize: "40px",
  fontWeight: "800",
  textAlign: "center",
};

const sunStyle: ThemeUIStyleObject = {
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const todayResultStyle: ThemeUIStyleObject = {
  alignSelf: "stretch",
  flex: "1 1 0%",
  padding: RAW_cssValue("120px 80px 80px"),
  textAlign: "left",
  whiteSpace: "pre-wrap",
  display: "flex",
  justifyContent: "center",
};

const todayResultCardStyle: ThemeUIStyleObject = {
  flex: "1 1 0%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  position: "relative",
  fontWeight: "300",
  textAlign: "center",
};

const todayResultTextfitStyle: ThemeUIStyleObject = {
  display: "flex",
  flex: "1 1 0%",
};
